var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center-cmp"},[_c('img',{attrs:{"src":require('@/assets/map.png')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }